<div *ngIf="config" class="tp-banner" data-cy="tripProtectionAlertBanner">
  <div class="tp-banner-row"></div>
  <div class="tp-banner-wrapper d-flex">
    <div class="col-md-auto iconSection col-sm-12 btmCls">
      <div class="headingOne" id="headingOne">
        <img
          alt="{{ config.icon.altLabel }}"
          src="{{ config.icon.iconPath }}"
        />
      </div>
    </div>
    <div class="col-md col-sm-12 msgSection">
      <h2 class="tp-banner-label">
        {{ config.tripProtectionBannerLabel }}
      </h2>
      <h3
        [innerHTML]="config.tripProtectionBannerMessage1"
        class="tp-banner-intro"
      ></h3>
    </div>
  </div>
</div>
